/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Button,
  Input,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Modal,
  CardBody,
  Form,
  Col,
} from 'reactstrap';
import Header from 'components/Headers/Header.js';
import { FaEdit, FaPlusCircle, FaTimesCircle } from 'react-icons/fa';
import Swal from 'sweetalert2';
import api from 'services/api';
import { ReportTemplate } from 'models/ReportTemplate';

import { iReport } from 'models/TemplateReport';
import SequenciaTipoOrdemVendaModel from 'models/SequenciaTipoOrdemVenda';

const ProdutoRelatorio: React.FC = () => {
  const [tipoAnteriorInsert, setTipoAnteriorInsert] = useState(
    {} as SequenciaTipoOrdemVendaModel | null | undefined,
  );
  const [tipoNovoInsert, setTipoNovoInsert] = useState({} as string);
  const [listaTipoOrdemVendaRaiz, setListaTipoOrdemVendaRaiz] = useState(
    [] as SequenciaTipoOrdemVendaModel[],
  );
  const [listaTipoOrdemVenda, setListaTipoOrdemVenda] = useState(
    [] as SequenciaTipoOrdemVendaModel[],
  );
  const [tipoOrdemVendaInicial, setTipoOrdemVendaInicial] = useState(0);
  const [listaReportContent, setListaReportContent] = useState([] as iReport[]);

  const [formModalState, setFormModalState] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  async function carregarTiposRaiz() {
    const response = await api.get(
      '/integracao/sequencia-tipo-ordem-venda/tipos-raiz',
    );

    console.log('response.data', response.data);
    setListaTipoOrdemVendaRaiz(response.data);
  }

  async function carregarSequenciaDaRaiz() {
    const response = await api.get(
      `/integracao/sequencia-tipo-ordem-venda/sequencia-da-raiz/${tipoOrdemVendaInicial}`,
    );

    console.log('response.data', response.data);
    setListaTipoOrdemVenda(response.data);
  }

  useEffect(() => {
    setIsLoading(true);
    carregarTiposRaiz();
    setIsLoading(false);
  }, []);

  useEffect(() => {
    console.log('tipoAnteriorInsert', tipoAnteriorInsert);
  }, [tipoAnteriorInsert]);

  useEffect(() => {
    if (tipoOrdemVendaInicial) {
      setIsLoading(true);
      carregarSequenciaDaRaiz();
      setIsLoading(false);
    }
  }, [tipoOrdemVendaInicial]);

  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        icon: 'info',
        text: `Buscando dados`,
        allowOutsideClick: false,
        showConfirmButton: false,
        showCancelButton: false,
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);

  useEffect(() => {
    if (isSaving) {
      Swal.fire({
        icon: 'info',
        text: `Salvando Registro`,
        allowOutsideClick: false,
        showConfirmButton: false,
        showCancelButton: false,
      });
    } else {
      Swal.close();
    }
  }, [isSaving]);

  async function recarregarDados(completo?: boolean) {
    try {
      setIsLoading(true);
      if (completo) {
        await carregarTiposRaiz();
      }
      await carregarSequenciaDaRaiz();
    } finally {
      setIsLoading(false);
    }
  }

  async function handleDelete(item: SequenciaTipoOrdemVendaModel) {
    Swal.fire({
      title: `Deseja remover o registro?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    }).then(async result => {
      Swal.close();
      if (result.isConfirmed) {
        setIsSaving(true);
        const isRaiz = item.tipoAnteriorId === null;
        const itemId = item.id;
        await api.delete(`/integracao/sequencia-tipo-ordem-venda/${itemId}`);
        toast.success('Registro removido');
        recarregarDados(isRaiz);
      }
      setIsSaving(false);
    });
  }

  async function handleInsert(
    itemNovo: string,
    itemAnterior?: SequenciaTipoOrdemVendaModel | null | undefined,
  ) {
    try {
      setIsSaving(true);
      const res = await api.post(`/integracao/sequencia-tipo-ordem-venda`, {
        itemAnterior,
        itemNovo,
      });
      console.log('handleInsert result', res.data);
      toast.success('Registro criado com sucesso!');
      setFormModalState(false); // close modal
      await recarregarDados(
        itemAnterior === null || itemAnterior === undefined,
      ); // recarrega dados lista de raiz se for um item raiz novo
      setIsSaving(false);
    } catch (err) {
      console.error(err);
      toast.error('Erro ao criar registro');
    }
  }

  return (
    <>
      <Header showCards={false} />
      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <FormGroup className="mb-4">
              <InputGroup>
                <Button
                  className="btn-icon btn-2"
                  color="primary"
                  type="button"
                  onClick={() => {
                    setTipoAnteriorInsert(null);
                    setTipoNovoInsert('');
                    setFormModalState(true);
                  }}
                >
                  <FaPlusCircle />
                </Button>
              </InputGroup>
            </FormGroup>
          </Col>
        </Row>

        {/* Table */}
        <Row>
          <div className="col">
            {/* Modal edição */}
            <Modal
              className="modal-dialog-centered"
              size="lg"
              isOpen={formModalState}
              toggle={() => setFormModalState(!formModalState)}
            >
              <div className="modal-body p-0">
                <Card className="bg-secondary shadow border-0">
                  <CardBody className="px-lg-5 py-lg-5">
                    <Form role="form">
                      <FormGroup className="mb-3">
                        <span>Código do Tipo:</span>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Código do Tipo"
                            type="text"
                            value={tipoNovoInsert || ''}
                            onChange={text =>
                              setTipoNovoInsert(text.target.value)
                            }
                          />
                        </InputGroup>
                      </FormGroup>

                      <div className="text-center">
                        <Button
                          className="my-4"
                          color="primary"
                          type="button"
                          disabled={!tipoNovoInsert}
                          onClick={async () => {
                            await handleInsert(
                              tipoNovoInsert,
                              tipoAnteriorInsert,
                            );
                          }}
                        >
                          Salvar
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </div>
            </Modal>

            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">
                  Sequência Tipo Ordem Venda x Relatórios
                </h3>
              </CardHeader>

              <CardBody>
                <Row>
                  <Col sm="12">
                    <small>
                      <strong>Tipo Ordem de Venda Inicial:</strong>{' '}
                    </small>
                    <Input
                      placeholder="Tipo Ordem de Venda Inicial"
                      type="select"
                      value={tipoOrdemVendaInicial}
                      onChange={text =>
                        setTipoOrdemVendaInicial(Number(text.target.value))
                      }
                    >
                      <option value="">Selecione...</option>
                      {listaTipoOrdemVendaRaiz.map(item => {
                        return (
                          <option value={item.id}>{item.codigoTipo}</option>
                        );
                      })}
                    </Input>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col sm="12">
                    <Table
                      className="align-items-center table-flush"
                      responsive
                    >
                      <thead className="thead-light">
                        <tr>
                          <th>Código Tipo</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listaTipoOrdemVenda.map(item => (
                          <tr key={item.id}>
                            <td className="py-2">{item?.codigoTipo ?? ''}</td>
                            <td className="py-2">
                              <div className="float-right">
                                <Button
                                  size="sm"
                                  className="btn-icon"
                                  color="primary"
                                  type="button"
                                  onClick={() => {
                                    setTipoAnteriorInsert(item);
                                    setTipoNovoInsert('');
                                    setFormModalState(true);
                                  }}
                                >
                                  <FaPlusCircle />
                                </Button>
                                <Button
                                  size="sm"
                                  className="btn-icon"
                                  color="warning"
                                  type="button"
                                  onClick={() => {
                                    handleDelete(item);
                                  }}
                                >
                                  <FaTimesCircle />
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ProdutoRelatorio;
